<template>
  <div>
    <div class="pb-8">
      <form v-on:submit.prevent>
        <label for="name">Nome</label>
        <input id="name" type="text" v-model="name" />
        <label for="login">Email</label>
        <input id="login" type="email" v-model="email" />
        <label for="password">Senha</label>
        <input id="password" type="password" v-model="password" />
        <label for="password-confirmation">Confirme a Senha</label>
        <input
          id="password-confirmation"
          type="password"
          v-model="password_confirmation"
        />

        <button @click="handleRegister" class="button button-primary mt-5">
          Cadastre-se
        </button>
      </form>
    </div>
    <div class="text-center">
      <p>
        já possui cadastro?
        <router-link to="/login">Faça o login</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      validationErrors: ""
    };
  },
  methods: {
    handleRegister() {
      // clean up validations
      this.validationErrors = "";
      this.$store
        .dispatch("register", {
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(() => {
          this.$router.push("/");
        })
        .catch(error => {
          this.$toasted.error(`Ops... Algo deu errado.`, {
            position: "top-center",
            duration: 3000,
            icon: "error_outline"
          });

          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
            this.$emit("validationErrors", this.validationErrors);
          }
        });
    }
  }
};
</script>
